export default __webpack_public_path__ + "static/media/calculate-24px.f06752f9.svg";